<template>
  <div>
    <div class="choice-wrapper" v-for="option of options">
      <input class="choice-input"
             type="radio"
             :id="`${prefix}-exclusive-${question.id}-${option}`"
             :name="`${prefix}-exclusive-${question.id}`"
             :value="option"
             v-model="value"
      >
      <label class="choice-label" :for="`${prefix}-exclusive-${question.id}-${option}`">{{ option }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'exclusive-choice',
  props: {
    question: Object,
    answer: String,
  },
  computed: {
    value: {
      get() {
        return this.answer;
      },
      set(answer) {
        this.$emit('change', answer);
      },
    },
    prefix() {
      return new Date().getTime();
    },
    options() {
      if (this.question) {
        if (this.question.options) {
          return this.question.options;
        } else if (this.question.params) {
          return this.question.params.options;
        }
      }
      return [];
    },
  },
};
</script>

<style scoped lang="scss">
.choice-wrapper {
  display: inline-block;
  position: relative;
  margin-bottom: 10px;

  .choice-label {
    display: block;
    padding: 0 10px;
    margin-right: 4px;
    margin-bottom: 0;
    background: white;
    border: 1px solid #757575;
    border-radius: 4px;
    position: relative;
    cursor: pointer;

    &:hover {
      background-color: #dae7d4;
      border-color: #91b269;
    }
  }

  .choice-input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked + .choice-label {
      background-color: #dae7d4;
      border-color: #91b269;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExclusiveChoice.vue